import LabelProvider from "core/components/label/LabelProvider";
import { badges } from "./fragments/course/displayFragments";


export default LabelProvider.create({

	BadgeClaim: { k: "badge.claim", v: "Claim Badge" },

	BadgeIssuedView: { k: "badge.view.issued", v: "Issued ${issued}", argNames: ["issued"] },

	BadgeEmptyTitle: { k: "badge.empty.title", v: "No Badges Found" },

	BadgeEmptyDesc: { k: "badge.empty.desc", v: "" },

	BadgeExpires: {k: "badge.expires", v: "Badge Expires: ${expiresAt}", argNames: ["expiresAt"]}



});



// WEBPACK FOOTER //
// ./src/panels/catalog/Badge.labels.ts